import {
  Bell,
  HelpCircle,
  Settings,
  Search,
  Plus,
} from "lucide-react";

const AdminLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="min-h-screen bg-[#f8f9ff] text-slate-900 overflow-x-hidden">

      <header className="h-16 sticky top-14 lg:top-0 z-20 flex justify-between items-center gap-2 px-3 sm:px-4 lg:px-6 bg-white border-b border-slate-200 shadow-sm">
        <div className="flex items-center gap-3 lg:gap-8 min-w-0">
          <span className="text-base lg:text-lg font-extrabold text-slate-900 tracking-tight whitespace-nowrap">
            Upwork Manager
          </span>
          <div className="relative hidden md:block md:w-44 lg:w-64">
            <Search
              size={16}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
            />
            <input
              placeholder="Search accounts..."
              className="w-full pl-10 pr-4 py-2 bg-slate-50 border border-slate-200 rounded-lg text-[13px] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>
        <div className="flex items-center gap-1.5 sm:gap-2 lg:gap-4 shrink-0">
          <div className="flex gap-0.5 sm:gap-1">
            <button className="p-2 text-slate-500 hover:bg-slate-50 transition rounded-full">
              <Bell size={18} />
            </button>
            <button className="hidden sm:inline-flex p-2 text-slate-500 hover:bg-slate-50 transition rounded-full">
              <HelpCircle size={18} />
            </button>
            <button className="p-2 text-slate-500 hover:bg-slate-50 transition rounded-full">
              <Settings size={18} />
            </button>
          </div>
          <button className="bg-[#0058c3] hover:opacity-90 text-white px-3 lg:px-4 py-2 rounded-lg font-semibold text-[13px] transition inline-flex items-center gap-1.5">
            <Plus size={15} />
            <span className="hidden sm:inline">Add Account</span>
          </button>
          <div className="w-9 h-9 rounded-full bg-gradient-to-br from-blue-400 to-blue-700 ring-2 ring-white shadow shrink-0" />
        </div>
      </header>

      <main className="min-w-0">{children}</main>
    </div>
  );
};

export default AdminLayout;
